// src/api/apiCountries.js
import axios from "../utils/axios";

/// Get Countries
export const getAllCountries = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("countries", { params });
    return data;
};

// Get Countries for Select Dropdown
export const getCountriesForSelect = async () => {
    const { data } = await axios.get("countries/for-select");
    return data;
};

/// Get Country
export const getCountry = async (id) => {
    if (!id) return null;

    // يدعم الشكلين: ?id= و /id مثل apiRoles
    const { data } = await axios.get(`countries/${id}`);
    return data;
};

/// Create Country
export const createCountry = async (req) => {
    try {
        const { data } = await axios.post("countries", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createCountry error:", error);
        throw error;
    }
};

/// Update Country
export const updateCountry = async (req, id) => {
    try {
        const { data } = await axios.put(`countries/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateCountry error:", error);
        throw error;
    }
};

/// Delete Country
export const deleteCountry = async (id) => {
    try {
        const { data } = await axios.delete(`countries/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteCountry error:", error);
        throw error;
    }
};

/// Delete All Countries (اختياري)
export const deleteAllCountries = async (req = []) => {
    try {
        const { data } = await axios.delete(
            "countries/mass-destroy",
            { data: req },
            { headers: { Accept: "application/json" }, }
        );
        return data;
    } catch (error) {
        console.error("deleteAllCountries error:", error);
        throw error;
    }
};


/// Restore Country
export const restoreCountry = async (id) => {
    try {
        const { data } = await axios.post(`countries/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreCountry error:", error);
        throw error;
    }
};

/// Restore multiple Countries
export const restoreAllCountries = async (req = []) => {
    try {
        const { data } = await axios.post(
            "countries/mass-restore",
            { ...req },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllCountries error:", error);
        throw error;
    }
};

/// Force Delete Country (موجودة بالفعل - تحسين الـ error handling)
export const forceDeleteCountry = async (id) => {
    try {
        const { data } = await axios.delete(`countries/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteCountry error:", error);
        throw error;
    }
};

/// Force Delete multiple Countries (موجودة بالفعل - تحسين الـ error handling)
export const forceDeleteAllCountries = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "countries/mass-force-delete",
            { data: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllCountries error:", error);
        throw error;
    }
};